import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import {
    CouponSegments,
    CreateCouponSegment,
} from './types'

class CouponSegmentsApi {
    private api: AxiosInstance

    constructor(config: AxiosRequestConfig) {
        this.api = apiClient.create(config)
    }

    getCampaignSegments = (campaignId: string) => {
        return this.api.get<CouponSegments>(`/gw2//karna/internal/v1/campaign-segment/${campaignId}`)
    }

    createCampaignSegment = (payload: CreateCouponSegment) =>
        this.api.post(`/gw2/karna/internal/v1/campaign-segment`, payload)

    deleteCouponSegment = (campaignSegmentId: string) =>
        this.api.delete(`/gw2/karna/internal/v1/coupon-segment/${campaignSegmentId}`)
}

export default CouponSegmentsApi